{
  "useInheritedPermissions": "Usa los permisos heredados de {{ resource }}",
  "permissions": "permisos",
  "addUserOrGroup": "Agregar usuario o grupo",
  "additionalPermissions": "Permisos adicionales",
  "inheritedPermissions": "Permisos heredados",
  "turnOffInheritance": "Desactiva la herencia",
  "turnOnInheritance": "Activa la herencia",
  "turnOnInheritanceDescription1": "Al activar esta opción, restablecerás los permisos heredados del padre.",
  "turnOnInheritanceDescription2": "Ten en cuenta que si vuelves a activarla, se perderán todos los permisos adicionales sobre este elemento.",
  "turnOffInheritanceDescription1": "Si lo desactiva, podrá ajustar los permisos de todos los usuarios y grupos de usuarios.",
  "turnOffInheritanceDescription2": "Tenga en cuenta que, si se interrumpe la cadena de herencia, los cambios futuros que se realicen en los permisos del elemento principal no se transferirán a este elemento.",
  "inheritanceChangesSaved": "Los cambios de herencia se guardan automáticamente.",
  "authLevels": {
    "admin": {
      "title": "Acceso completo",
      "descriptionPlan": "Edite el acceso y elimine, cambie el nombre y administre los permisos",
      "descriptionFolder": "Cree planes y carpetas, cámbieles el nombre y suprima",
      "descriptionLayer": "Edite el acceso y elimine, cambie el nombre y administre los permisos"
    },
    "write": {
      "title": "Editar",
      "descriptionPlan": "Crea y edita objetos y atributos",
      "descriptionFolder": "Puede agregar planes y subcarpetas",
      "descriptionLayer": "Crea y edita objetos y atributos"
    },
    "read": {
      "title": "Ver",
      "descriptionPlan": "Puede ver el plan y agregar comentarios",
      "descriptionFolder": "Puede ver el contenido de la carpeta",
      "descriptionLayer": "Puede ver los objetos que pertenecen a esta capa"
    },
    "deny": {
      "title": "Sin acceso",
      "descriptionPlan": "No se puede ver el plan",
      "descriptionFolder": "No se puede ver el contenido de la carpeta",
      "descriptionLayer": "No se pueden ver los objetos que pertenecen a esta capa"
    }
  },
  "usersGroups": {
    "searchLabel": "Introduzca un nombre o un grupo",
    "searchTitle": "Busca a un colega"
  },
  "permissionsEditTitle": "Establece los permisos de edición de {{ nodeType }}",
  "resourceLockDescription1": "Los permisos están bloqueados y nadie puede modificarlos.",
  "resourceLockDescription2": "Los administradores pueden desbloquearlos en cualquier momento.",
  "unlockButtonText": "Desbloquee para permitir la edición",
  "inheritedLockDescription1": "Nadie puede realizar modificaciones debido a un bloqueo en cascada impuesto por uno de los padres.",
  "inheritedLockDescription2": "Los administradores pueden desbloquearlo accediendo a la configuración principal.",
  "lock": "Bloquear",
  "inheritedPermissionsHelpText": "Con esta configuración activada, este objeto utilizará los permisos establecidos por el objeto principal.",
  "linkExpiredModal": {
    "title": "El enlace ha caducado",
    "content": "Este enlace ha caducado o no es válido.\n Ponte en contacto con el usuario que creó el enlace si necesitas acceso."
  },
  "copyPermissions": "Copiar permisos"
}